export default {
  ugNumber: [
    {
      key: "numeric",
      message: "UG nummer måste vara siffror",
      id: "numeric",
    },
  ],
};
